import React from 'react';
import { observer } from 'mobx-react';
import ChatStatusButtons from './atoms/ChatStatusButtons';
import ErrorBoundary from '../../ErrorBoundary';
import Module from './modules';
import { PortalHost, PortalName } from '../../portals';
import classNames from 'classnames';
import { useLocation } from 'react-router-dom';
import useCheckIfMobile from '../../../helpers/hooks/useCheckIfMobile';
import styles from './RightBar.module.scss';
/** The most simple solution to remove the right when not needed is if it keeps the same width */
const HIDE_RIGHT_BAR_PREFIXES = ['/notifications', '/manage'];
const RightBar = () => {
    const { pathname } = useLocation();
    const isMobile = useCheckIfMobile();
    const shouldHideBasedOnPath = HIDE_RIGHT_BAR_PREFIXES.some(prefix => pathname.startsWith(prefix));
    if (isMobile) {
        return null;
    }
    return (React.createElement("div", { className: classNames(styles.rightBar, { [styles.hide]: shouldHideBasedOnPath }) },
        React.createElement(ErrorBoundary, null,
            React.createElement(PortalHost, { name: PortalName.rightBarContents, className: styles.rightBarContents },
                React.createElement(Module, null))),
        React.createElement(ChatStatusButtons, { visible: true })));
};
export default observer(RightBar);
